// extracted by mini-css-extract-plugin
export var backdropBlur = "_fr-0";